import { Search } from '@domain-group/suit-theme'

import { CampaignModel } from '@models/types'

import searchFn from '@functions/search'

const mapResults = (results: CampaignModel[]) => {
  if (!results.length){
    return {}
  }

  const groups = [{
    items: results.map((result: CampaignModel) => {
      const {
        id,
        title,
      } = result

      return {
        ...result,
        key: id,
        secondaryText: `Campaign ID #${id}`,
        text: title,
      }
    }),
    key: 'campaigns',
    title: 'Campaigns',
  }]

  const mapped = {
    groups,
  }

  return mapped
}

interface CampaignSearchProps {
  callbacks: {
    onChange: (value: string) => void,
    selectItem: (item: CampaignModel) => void,
  },
  value: string,
}

const CampaignSearch = (props: CampaignSearchProps) => {
  const {
    callbacks: {
      onChange,
      selectItem,
    },
    value,
  } = props

  return (
    <Search
      callbacks={{
        onChange,
        // @ts-expect-error TS2322
        search: searchFn,
        // @ts-expect-error TS2322
        selectItem,
        // @ts-expect-error TS2322
        mapResults,
      }}
      debounceInterval={300}
      endpoint="campaigns.json"
      forwardProps={{
        closeOnSelect: true,
        setStringOnSelect: false,
        showOnFocus: true,
      }}
      requestOptions={{}}
      value={value}
    />
  )
}

export default CampaignSearch
